import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import ConfirmRadio from '../../../base/radio/ConfirmRadio';
import FormFields from './Maintenance.fields';

export { default as maintenanceSchema } from './Maintenance.schema';
export { DefaultValues as maintenanceDefaults, default as maintenanceFormFields } from './Maintenance.fields';

export const Maintenance = ({ classes }) => {
  const { control } = useFormContext();
  return (
    <>
      <ConfirmRadio
        control={control}
        name={FormFields.maintenance.name}
        id={FormFields.maintenance.id}
        trueLabel={FormFields.maintenance.trueLabel}
        falseLabel={FormFields.maintenance.falseLabel}
        ariaDescribedBy={FormFields.maintenance.ariaDescribedBy}
        title="Maintenance page status"
        titleHeading="h3"
        additionalHeading="(required)"
        description={FormFields.maintenance.description}
        descriptionNote
        ariaRequired={true}
      />
    </>
  );
};

Maintenance.propTypes = {
  classes: PropTypes.shape({}),
};
Maintenance.defaultProps = {
  classes: {},
};

export default Maintenance;
